import { Box, Paper, Typography } from "@mui/material";
import { GAS_UNIT } from "../models/GasConsumption";

interface Props {
	total: number;
	max: number;
}

const fmt = (n: number) =>
	n.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

export const GasConsumptionSummary = ({ total, max }: Props) => {
	return (
		<Paper elevation={1} sx={{ px: 2, py: 0.75 }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 4,
					flexWrap: "wrap",
				}}
			>
				<Typography variant="body2">
					<strong>Total:</strong> {fmt(total)} {GAS_UNIT}
				</Typography>
				<Typography variant="body2">
					<strong>Max:</strong> {fmt(max)} {GAS_UNIT}
				</Typography>
			</Box>
		</Paper>
	);
};
